<div class="d-flex justify-content-center align-items-center" style="margin-left:20px">
  <svg-icon src="/assets/icons/step-done.svg" class="me-3"></svg-icon>
  <svg-icon class="me-3"
    src="{{step >= 2  ? '/assets/icons/step-done.svg' : '/assets/icons/step-empty.svg'}}"></svg-icon>
  <svg-icon class="me-3"
    src="{{step >= 3 ? '/assets/icons/step-done.svg' : '/assets/icons/step-empty.svg'}}"></svg-icon>
  <svg-icon class="me-3"
    src="{{step >= 4 ? '/assets/icons/step-done.svg' : '/assets/icons/step-empty.svg'}}"></svg-icon>
</div>
<div class="step-pagination">
  <div class="text-center my-3 d-flex justify-content-between align-items-center">
    <svg-icon [src]="'/assets/icons/arrow-gray-left.svg'" class="cursor-pointer" (click)="onPrevStep()"
      *ngIf="step > 1"></svg-icon>
    <span *ngIf="step == 1"></span>
    <span>{{step+'/'+4}}</span>
    <svg-icon [src]="'/assets/icons/arrow-light-right.svg'" *ngIf="!firstStepFormControl.valid && step == 1"></svg-icon>
    <svg-icon [src]="'/assets/icons/arrow-gray-right.svg'" class="cursor-pointer" (click)="onSubmit()"
      *ngIf="firstStepFormControl.valid && step == 1"></svg-icon>

    <svg-icon [src]="'/assets/icons/arrow-light-right.svg'"
      *ngIf="!secondStepFormControl.valid && step == 2"></svg-icon>
    <svg-icon [src]="'/assets/icons/arrow-gray-right.svg'" class="cursor-pointer" (click)="onSubmit()"
      *ngIf="secondStepFormControl.valid && step == 2"></svg-icon>


    <svg-icon [src]="'/assets/icons/arrow-light-right.svg'" *ngIf="!thirdStepFormControl.valid && step == 3"></svg-icon>
    <svg-icon [src]="'/assets/icons/arrow-gray-right.svg'" class="cursor-pointer " (click)="onSubmit()"
      *ngIf="thirdStepFormControl.valid && step == 3"></svg-icon>

    <svg-icon [src]="''" *ngIf="step == 4"></svg-icon>
    <!-- <svg-icon [src]="'/assets/icons/arrow-gray-right.svg'" class="cursor-pointer " (click)="onSubmit()" *ngIf="finalStepFormGroup.valid && step == 4"></svg-icon> -->
  </div>

  <app-first-form-step [firstStepFormControl]="firstStepFormControl" [type]="type" (onSubmit)="onSubmit()"
    *ngIf="step == 1"></app-first-form-step>

  @if (type == 'etablissement') {
  <app-second-form-step [firstStepFormControl]="firstStepFormControl" [secondStepFormControl]="secondStepFormControl"
    (onSubmit)="onSubmit()" *ngIf="step == 2"></app-second-form-step>


  <app-third-form-step [firstStepFormControl]="firstStepFormControl" [secondStepFormControl]="secondStepFormControl"
    [thirdStepFormControl]="thirdStepFormControl" [addressForm]="addressForm" (onSubmit)="onSubmit()"
    (addNewSite)="addNewSite()" [removeNewSite]="removeNewSite" *ngIf="step == 3"></app-third-form-step>

  <app-final-form-step *ngIf="step == 4" [finalStepFormGroup]="finalStepFormGroup" (onSubmit)="onSubmit()"
    [removeNewContact]="removeNewContact" [contacts]="contacts" [contactForm]="contactForm" [loading]="loading"
    [phoneSelected]="phoneSelected"></app-final-form-step>
  } @else if (type == 'candidat') {
  <app-candidat [step]="step" [firstStepFormControl]="firstStepFormControl"
    [secondStepFormControl]="secondStepFormControl" [thirdStepFormControl]="thirdStepFormControl"
    [addressForm]="addressForm" (onSubmit)="onSubmit()"></app-candidat>
  }
</div>
